import { client } from "../../../Infrastructure/agent";
export const registerService = {
  getBrandsAndDept: () => client.get("/main/getinitialdata"),
};

